export function GLP1Page() {
  return (
    <>
      <h1 style={{ fontSize: 32, color: 'var(--primary)', marginBottom: 8 }}>GLP-1 Program</h1>
      <div
        style={{
          padding: '12px 16px',
          background: 'var(--mint)',
          borderRadius: 10,
          fontSize: 13.5,
          color: 'var(--primary)',
          marginBottom: 20,
          maxWidth: 720,
        }}
      >
        <strong>PHI-free roster.</strong> No weights, doses, side effects, trends, or photos —
        all on paper + member's phone. This view shows enrollment + visit cadence only.
      </div>
      <div style={{ padding: 24, background: 'var(--card)', borderRadius: 14, border: '1px solid var(--line-soft)' }}>
        <p style={{ color: 'var(--text-muted)' }}>Stub — wires to glp1_members table once schema is applied.</p>
      </div>
    </>
  );
}
